import { FormStatusCounts } from '@features/forms/types';

const toCount = (value: unknown): number =>
  typeof value === 'number' && Number.isFinite(value) ? value : 0;

export const mapFormStatusCounts = (payload: unknown): FormStatusCounts => {
  const source =
    payload && typeof payload === 'object' && 'data' in payload
      ? (payload as { data: unknown }).data
      : payload;

  const counts = (source ?? {}) as Record<string, unknown>;
  const published = toCount(counts.published);
  const paused = toCount(counts.paused);
  const closed = toCount(counts.closed);

  return {
    published,
    paused,
    closed,
    all: published + paused + closed
  };
};

export default mapFormStatusCounts;
